import {createSlice} from '@reduxjs/toolkit'

export const popupSlice = createSlice({
    name: 'popup',
    initialState: {},
    reducers: {
        onOpenPopup: (state, action) => {
            state[action.payload.owner] = action.payload;
        },
        onClosePopup: (state, action) => {
            state[action.payload.name] = null;
        }
    }
})

export const {
    onOpenPopup,
    onClosePopup
} = popupSlice.actions;

export default popupSlice.reducer;